import { render, staticRenderFns } from "./emergencyApply.vue?vue&type=template&id=dd83b8e8&scoped=true&"
import script from "./emergencyApply.vue?vue&type=script&lang=js&"
export * from "./emergencyApply.vue?vue&type=script&lang=js&"
import style0 from "./emergencyApply.vue?vue&type=style&index=0&id=dd83b8e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd83b8e8",
  null
  
)

export default component.exports